"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceConfig = void 0;
const tslib_1 = require("tslib");
const ModelCommon_1 = require("../../model/ModelCommon");
const constructs_1 = require("../constructs");
const className = 'DeviceConfig';
const maxRecentStates = 5;
/**
 * @class Holds configuration object retrieved from device via downlink request
 * This is a pseudo property ie an instance should have pk as the sk of the device it belongs to,
 * And since it can only have one config, the instances sk should be a concaentation of pk + className
 */
class DeviceConfig extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(className, { ...ob });
        this.type = 'DeviceConfig';
        this.update = (update, payloadAttributesMetaTypes) => {
            if (update.reported) {
                if (!this.reported) {
                    this.reported = {};
                }
                const { meta, messageType, ...reportable } = this.reported;
                this.recentReported.unshift(reportable);
                // trim
                if (this.recentReported.length > this.maxRecentStates) {
                    this.recentReported.pop();
                }
                this.lastReportedMs = update.reported.timestamp;
                /** merge to this.reported */
                Object.entries(update.reported).forEach(([k, v]) => {
                    /** use transform is available */
                    if (v && payloadAttributesMetaTypes?.[k]?.transformIn) {
                        if (this.reported && !this.reported[k]) {
                            ;
                            this.reported[k] = {};
                        }
                        const existingValue = this.reported?.[k];
                        const update = payloadAttributesMetaTypes[k].transformIn?.(v, existingValue);
                        if (update) {
                            ;
                            this.reported[k] = update;
                        }
                    }
                    else {
                        ;
                        this.reported[k] = v;
                    }
                });
            }
            if (update.requested) {
                if (update.requested.broadcastScheduleSk) {
                    this.lastRequestedBroadcastScheduleSk = update.requested.broadcastScheduleSk;
                }
                this.lastRequestedMs = update.requested.timestamp;
                this.requested = this.requested ? Object.assign(this.requested, update.requested) : update.requested;
                this.recentRequested.unshift(update.requested);
                if (this.recentRequested.length > maxRecentStates) {
                    this.recentRequested.pop();
                }
            }
            this.metadata = { ...this.metadata, lastUpdatedMs: Date.now() };
        };
        this.maxRecentStates = ob.maxRecentStates ?? maxRecentStates;
        this.metadata = ob.metadata; // 2024 09 fix for overwriting property from ModelCommon -- this needs typing probably
        this.lastRequestedBroadcastScheduleSk = ob.lastRequestedBroadcastScheduleSk;
        this.recentReported = ob.recentReported instanceof Array ? ob.recentReported : [];
        this.recentRequested = ob.recentRequested instanceof Array ? ob.recentRequested : [];
        /** temporary cleaning of exisiting data  */
        if (this.recentStates) {
            delete this.recentStates;
        }
    }
    static createForDevice(device) {
        const sk = `${device.sk}_${className}`;
        const pk = device.pk;
        const name = `${device.name ?? device.sk} DeviceConfig`;
        const id = `${device.id}_${className}`;
        return new DeviceConfig({ sk, pk, name, id });
    }
}
exports.DeviceConfig = DeviceConfig;
tslib_1.__decorate([
    (0, constructs_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], DeviceConfig.prototype, "update", void 0);
